import { Messages } from '../../../../../gen-src/Localize';

export function messageForConnectionType(connectionType: string | null): string | null {
  if (!connectionType) {
    return connectionType;
  }
  const messageKey = connectionTypeToMessageKey(connectionType);
  const MessagesMap = Messages as { [key: string]: (params?: unknown) => string };

  return Object.prototype.hasOwnProperty.call(MessagesMap, messageKey) ? MessagesMap[messageKey]() : connectionType;
}

// This method is also used to generate the connection type messages so
// make the sure the connection type can be a legal javascript function name
// NOTE: After modifying this method, run `yarn run generate-connection-type-messages` and merge in the modified messages files
export function connectionTypeToMessageKey(connectionType: string): string {
  return 'CONNECTION_TYPE_' + connectionType.replace(/:|-/g, '_');
}
